import api from '../api'

// initial state
const state = {
  exams: {
    list: [],
    pageCount: 0,
    totalCount: 0,
    pageIndex: 1,
    pageSize: 10
  },
  exam: null
}

// getters
const getters = {
  exams: state => state.exams,
  exam: state => state.exam
}

// actions
const actions = {
  getExamList: ({ commit, state }) => {
    api.get('/Exam')
      .then((response) => {
        commit('updateExamList', response.data)
      })
  },

  getExam: ({ commit, state }, id) => {
    api.get('/Exam/' + id + '/Start')
      .then((response) => {
        commit('updateExam', response.data)
      })
  },

  postAnswers: ({ state }, data) => {
    return api.post('/Exam/' + data.id + '/Answer', data.answers)
  }
}

// mutations
const mutations = {
  updateExamList (state, payload) {
    state.exams.list = payload.data || []
    state.exams.pageCount = payload.pageCount
    state.exams.totalCount = payload.totalCount
    state.exams.pageIndex = payload.pageIndex
    state.exams.pageSize = payload.pageSize
  },

  updateExam (state, payload) {
    state.exam = payload.data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/exam.js